<sm-dialog-template>
  <div class="content">
    <div class="search-container">
      <div></div>
      <sm-search
        #searchComponent
        class="outline"
        [class.regex-error]="regexError"
        [value]="(searchQuery$ | ngrxPush)?.query"
        [hideIcons]="true"
        [minimumChars]="3"
        (valueChanged)="search($event)"
      >
        @if (regexError) {
          <mat-icon class="error regexp" fontSet="al" fontIcon="al-ico-error-circle" inline [smTooltip]="regexError" [matTooltipPosition]="'below'"></mat-icon>
        }
        <button mat-icon-button
                class="regexp sm"
                [class.active]="regExp"
                smClickStopPropagation
                [smTooltip]="'Regex'" [matTooltipPosition]="'below'"
                (click)="toggleRegExp(); searchComponent.searchBarInput().nativeElement.focus();"
        >
          <mat-icon fontSet="al" fontIcon="al-ico-regex" data-id="enableRegexButton"></mat-icon>
        </button>
      </sm-search>
        <sm-show-only-user-work></sm-show-only-user-work>
    </div>
    <sm-dashboard-search (itemSelected)="closeDialog()"></sm-dashboard-search>
  </div>
</sm-dialog-template>
